export const initColorConfig = (colorConfig) => {
  Object.keys(colorConfig).forEach((item) => {
    document.documentElement.style.setProperty(`--${item}`, colorConfig[item]);
    document.body.style.setProperty(`--${item}`, colorConfig[item]);
  });
};
